import api from '@/apis/di/voucherTypeAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';

// Combo grid Voucher Type
export const useVoucherTypeComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onVoucherTypeComboboxLoadData = (payload, row, column) => {
    payload.sort = 'voucher_type_code';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const voucherTypeComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại CT',
        dataField: 'voucher_type_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại CT',
        dataField: 'voucher_type_name',
        width: 480,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'voucher_type_code',
    valueField: 'voucher_type_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onVoucherTypeComboboxLoadData,
  };

  return {
    voucherTypeComboConfig,
    onVoucherTypeComboboxLoadData, // trả về thêm để dùng chung chả cả combo ko thuộc grid
  };
};
